import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {
    hits_available: 0,
    hits_consumed: 0,
    invoices: 0,
    cancellations: 0,
  },
  usage: {
    labels: [],
    data: [],
  },
};

const summary = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.dashboard.summary.busy = true;
  });

  try {
    const params = {
      ...meta,
    };

    const response = await Http.get('app/empresas/dashboard', { params });

    store.setState((state) => {
      state.app.dashboard.summary.busy = false;
      state.app.dashboard.summary.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.dashboard.summary.busy = false;
      state.app.dashboard.summary.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.dashboard.summary = { ...initialState };
  });
};

const DashboardSummaryStore = {
  state: () => initialState,
  actions: {
    summary,
    reset,
  },
};

export default DashboardSummaryStore;
